import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { DateTime } from "luxon";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { MultiSelect } from "primereact/multiselect";
import { DateObject } from "react-multi-date-picker";
import PanelHeaderTemplate from "../components/CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";

const filter = createFilterOptions();


export const dateConvert = (dateString, formate) => {
    if (!dateString) {
        return null
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        dateString += "T00:00:00";
    }
    const date = new Date(dateString);
    const day = (date.getDate())?.toString()?.padStart(2, "0");
    const month = (date.getMonth() + 1)?.toString()?.padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Use toLocaleString to get the abbreviated month name
    const monthName = date.toLocaleString('en-US', { month: 'short' });
    const fullNonthName = date.toLocaleString('en-US', { month: 'long' });
    // 24-hour format time (HH:mm)
    const hours24 = String(hours).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    if (formate === "date-time") {
        return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`
    } else if (formate === "time") {
        return `${hours}:${minutes} ${ampm}`
    }
    else if (formate === 'iso-string') {
        if (!date.getTime()) return "";
        return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
    }
    else if (formate === 'date-time-month') {
        return `${monthName} ${day}, ${year}, ${hours}:${minutes} ${ampm}`;
    }
    else if (formate === "hour-min") {
        return `${hours24}:${minutes}`; // 24-hour format
    }
    else if (formate === 'day-month-year') {
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-GB', options);
    }
    else if (formate === 'date-time-months') {
        return ` ${day} ${monthName} ${year} ${hours}:${minutes} ${ampm}`;
    } else if (formate === "day-mon-year") {
        return `${day} ${monthName} ${year}`;
    } else if (formate === "day-fullmonth-year") {
        return `${day} ${fullNonthName} ${year}`;
    } else if (formate === "date-month-year") {
        return `${day}-${month}-${year}`;
    } else if (formate === "month-year") {
        return `${monthName} ${year}`;
    } else if (formate === 'month-date-year-at-time') {
        return `${fullNonthName} ${day}, ${year} at ${hours}:${minutes} ${ampm}`;
    } else {
        return `${day}/${month}/${year}`
    }
};

export function getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);
    return date.toLocaleString('en-US', { month: 'short' });
}

export function toLocalDateString(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
export const monthsOptions = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
];

export const monthsOpt = [
    { value: 1, label: '1 Month' },
    { value: 2, label: '2 Month' },
    { value: 3, label: '3 Month' },
    { value: 4, label: '4 Month' },
    { value: 5, label: '5 Month' },
    { value: 6, label: '6 Month' },
    { value: 7, label: '7 Month' },
    { value: 8, label: '8 Month' },
    { value: 9, label: '9 Month' },
    { value: 10, label: '10 Month' },
    { value: 11, label: '11 Month' },
    { value: 12, label: '12 Month' },
];
export const yearsOpt = Array.from({ length: 10 }, (_, i) => {
    return { value: i + 1, label: i + 1 + " Year" };
});
export const yearsOptions = Array.from({ length: 10 }, (_, i) => {
    const currentYear = new Date().getFullYear();
    return { value: currentYear - i, label: currentYear - i };
});
export const FutureyearsOptions = Array.from({ length: 5 }, (_, i) => {
    const currentYear = new Date().getFullYear();
    return { value: currentYear + i - 2, label: currentYear + i - 2 };
});

export function convertDynamicDate(dateString) {
    // Parse the date string
    const parsedDate = DateTime.fromFormat(dateString, "dd-LLL-yyyy");
    const adjustedDate = parsedDate.set({
        year: parsedDate.year,
        month: parsedDate.month,
        day: parsedDate.day,
        hour: 8,
        minute: 8,
        second: 38,
        millisecond: 455
    });

    const isoDate = adjustedDate?.toFormat("yyyy-MM-dd'T'HH:mm:ss");

    return isoDate;
}


export function convertTo12HourFormat(time) {
    if (!time) {
        return;
    }
    const [hours, minutes] = time?.split(':')?.map(Number);
    let ampm = hours < 12 ? 'AM' : 'PM';
    let newHours = hours % 12;
    if (newHours === 0) {
        newHours = 12;
    }
    return `${newHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
}

export const convertTo24HourFormat = (timeStr, returnFullTime) => {
    const cleanedTime = timeStr?.replace(/\s+/g, '')?.toUpperCase();
    if (!cleanedTime?.match(/(\d{1,2}:\d{2})(AM|PM)/)) return console.error("Error: ", "Invalid Time String");
    const [time, modifier] = cleanedTime?.match(/(\d{1,2}:\d{2})(AM|PM)/)?.slice(1);
    let [hours, minutes] = time?.split(':')?.map(Number);

    if (modifier === 'PM' && hours !== 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    return returnFullTime ? `${hours?.toString()?.padStart(2, '0')}:${minutes?.toString()?.padStart(2, '0')}:00` : `${hours?.toString()?.padStart(2, '0')}:${minutes?.toString()?.padStart(2, '0')}`;
}

export function secondsToHours(seconds) {
    if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60);
        return minutes + "m";
    } else {
        const hours = seconds / 3600;
        return hours + "h";
    }
}

export const hourStringtoHours = (hourString) => {
    if (!hourString) return;

    let str = hourString?.toLowerCase();
    let hours = 0;
    hourString?.split(" ")?.forEach(item => {
        if (item?.includes("d")) {
            hours += parseInt(item?.split("d")?.[0]) * 24;
        } else if (item?.includes("h")) {
            hours += parseInt(item?.split("h")?.[0]);
        } else if (item?.includes("m")) {
            hours += parseInt(item?.split("m")?.[0]) / 60;
        }
    })
    return hours;
}

export function createAbbreviation(phrase) {
    const words = phrase?.split(" ");
    const abbreviation = words?.map(word => word[0]?.toUpperCase()).join("");
    return abbreviation;
}

//   padding:15px !important; 
//     border:1px solid red !important;
//     border-radius:10px !important;
//     color:red !important;
//     font-size: var(--font-size-xxl) !important;
//     font-family: var(--font-sans) !important;
//     outline:none;
//     transition:.3s;
//     background-color: #94a3b8;
//     outline: none;
//     height: auto !important;

export const MuiTextInputStyle = {
    '& .MuiOutlinedInput-root': {
        '& input': {
            border: 'none',
            
        },
        '&:hover input': {
            border: 'none',
        },
    },
    '& .css-segi59': {
        borderRadius: 0
    },
}

export const MuiCss = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        
    },
    '& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
        borderRadius: 0
    },
    '& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root': {
        borderRadius: 0, padding:'15px'
    },
    '& .css-segi59': {
        borderRadius: 0
    },
    '& .MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root': {
        padding: 0,
    },
    '& .MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
        padding: 0,
    },
    '& .css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root': {
        padding: 0,
    },
}

export const formatDateObject = (dateObj, time) => {
    const fullDate = new DateObject({
        year: dateObj?.year,
        month: dateObj?.month,
        day: dateObj?.day,
        hour: new Date(time)?.getHours(),
        minute: new Date(time)?.getMinutes(),
        second: new Date(time)?.getSeconds() || 0,
    });
    const formattedDate = fullDate?.format("YYYY-MM-DDTHH:mm:ss");
    return formattedDate;
}


// Helper to render a field
export const renderField = (field, index, handleChange, formValues, formErrors = {}, fromInventory, setInventoryEdit, validateInventoryError) => {

    const { label, name, type, required, option, col, disabled, hide, placeholder, optionLabel, optionValue, min, max, showClear, labelClassName, onHide, dateFormat } = field;
    const colClass = col ? `col-md-${col} ${fromInventory?.fromAwards ? "p-0" : (fromInventory ? "py-1" : "py-2")}` : "col-12 py-2";
    const error = formErrors[name];
    if (hide) return

    if (type === "select") {
        return (
            <div key={index} className={colClass}>
                {
                    label && <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>{label} <span className="text-danger">{required && "*"}</span></label>
                }
                <Dropdown
                    name={name}
                    options={option || []}
                    optionLabel={optionLabel || "label"}
                    optionValue={optionValue}
                    placeholder={placeholder || "Select"}
                    className="sk-input-dd w100"
                    onChange={handleChange}
                    value={formValues[name]}
                    disabled={disabled}
                    filter
                    filterInputAutoFocus
                    showClear={showClear}
                />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );
    } if (type === "multiselect") {
        return (
            <div key={index} className={colClass}>
                {
                    label && <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>{label} <span className="text-danger">{required && "*"}</span></label>
                }
                <MultiSelect
                    name={name}
                    options={option || []}
                    optionLabel={optionLabel}
                    placeholder={placeholder}
                    className="sk-multiselect w100"
                    onChange={handleChange}
                    value={formValues[name]}
                    optionValue={optionValue}
                    disabled={disabled}
                    onHide={onHide}
                    filter
                    filterInputAutoFocus
                    panelHeaderTemplate={(options) => PanelHeaderTemplate(options, name, formValues?.[name], () => handleChange({ target: { value: [] } }))}
                />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        )
    }
    if (type === "textarea") {
        return (
            <div key={index} className={`${colClass} w100`}>
                {
                    label && <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>{label} <span className="text-danger">{required && "*"}</span></label>
                }
                <textarea placeholder={placeholder || ""} name={name} className="w100 rounded" onChange={handleChange} value={formValues[name]} disabled={disabled} />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );
    }
    if (type === "number" || type === "text") {
        return (
            <div key={index} className={`${colClass} w100`}>
                {label && <label className={`detail-label ${labelClassName ? labelClassName : ""} ${fromInventory ? "d-flex justify-content-between" : ""}`}>
                    <div> {label} <span className="text-danger">{required && "*"}</span></div>
                    {(fromInventory?.is_edit && fromInventory?.fromProject) ?
                        <div className="c-pointer" onClick={() => setInventoryEdit(name)}><FontAwesomeIcon icon="fa-solid fa-xmark" /></div>
                        : ""}
                </label>}
                <input
                    name={name}
                    type={type}
                    min={(type === "number" && min) ? min : undefined}
                    className="sk-input-dd w100"
                    onChange={(e) => handleChange(e, fromInventory?.is_edit ? true : false)}
                    value={formValues[name]}
                    disabled={disabled}
                    placeholder={placeholder || ""}
                    onBlur={() => { if (fromInventory && !fromInventory?.fromProject && !fromInventory?.fromAwards) { validateInventoryError(); } }}
                />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );
    }
    if (type === "file") {
        return (
            <div key={index} className={`${colClass} w100`}>
                <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>
                    {label} <span className="text-danger">{required && "*"}</span>
                </label>
                <br />
                <div className="d-flex gap-2 align-items-center">
                    {formValues[name] && (
                        <div className="d-flex gap-2 align-items-end">
                            {typeof formValues[name] === 'string' || formValues[name] instanceof File ? (
                                formValues[name].name?.toLowerCase().endsWith('.pdf') ||
                                    (typeof formValues[name] === 'string' && formValues[name].toLowerCase().endsWith('.pdf')) ? (
                                    <FontAwesomeIcon
                                        icon="fa-solid fa-file-pdf"
                                        style={{ fontSize: "80px", color: "gray", cursor: "pointer" }}
                                        onClick={() => {
                                            const url =
                                                typeof formValues[name] === 'string'
                                                    ? formValues[name]
                                                    : URL.createObjectURL(formValues[name]);
                                            window.open(url, '_blank');
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={
                                            typeof formValues[name] === 'string'
                                                ? formValues[name]
                                                : URL.createObjectURL(formValues[name])
                                        }
                                        alt=""
                                        width={80}
                                        height={80}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            const url =
                                                typeof formValues[name] === 'string'
                                                    ? formValues[name]
                                                    : URL.createObjectURL(formValues[name]);
                                            window.open(url, '_blank');
                                        }}
                                    />
                                )
                            ) : null}

                        </div>
                    )}
                    <div>
                        <button
                            type="button"
                            onClick={() => document.getElementById(`fileInput-${name}`).click()}
                            className="btn-default btn-sm my-2"
                        >
                            <FontAwesomeIcon
                                icon="fa-solid fa-upload"
                                style={{ cursor: "pointer" }}
                            />  {formValues[name] ? "Change" : "Upload"}
                        </button>
                    </div>
                </div>
                <input
                    id={`fileInput-${name}`}
                    name={name}
                    type={type}
                    onChange={handleChange}
                    disabled={disabled}
                    style={{ display: formValues[name] ? 'none' : 'none' }}
                />

                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>

        );
    }
    if (type === "month" || type === "year" || type === "date" || type === "datetime") {
        let dateValue = null;
        if (formValues[name]) {
            if (type === "year" && (typeof formValues[name] === "number" || typeof formValues[name] === "string")) {
                dateValue = new Date(`${formValues[name]}-01-01`);
            } else {
                dateValue = new Date(formValues[name]);
            }
            // If dateValue is invalid, reset to null
            if (isNaN(dateValue.getTime())) {
                dateValue = null;
            }
        }

        return (
            <div key={index} className={`${colClass} w100 inspectra-calendar`}>
                {
                    label && <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>
                        {label} <span className="text-danger">{required && "*"}</span>
                    </label>
                }

                <Calendar
                    value={dateValue}
                    name={name}
                    onChange={handleChange}
                    view={type === "datetime" ? "date" : type}
                    disabled={disabled}
                    dateFormat={type === "month" ? "mm/yy" : (type === "year" ? "yy" : (dateFormat ? dateFormat : "dd/mm/yy"))}
                    className="input-dd"
                    showTime={type === "datetime"}
                    hourFormat={type === "datetime" ? "12" : undefined}
                    placeholder={placeholder}
                    minDate={min}
                    maxDate={max}
                />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );
    }

    if (type === "switch") {
        return (
            <div key={index} className={`${colClass} w100`}>
                <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>{label} <span className="text-danger">{required && "*"}</span></label><br></br>
                <div className="stage-toggle custom-switch-wrapper">
                    <InputSwitch
                        inputId="stage-switch"
                        checked={formValues[name]}
                        onChange={handleChange}
                        name={name}
                        disabled={disabled}
                    />
                    <span className={`switch-label ${formValues[name] ? 'on' : 'off'}`}>
                        {formValues[name] ? "Yes" : "No"}
                    </span>
                </div>
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );

    }
    if (type === "autocomplete") {
        return (
            <div key={index} className={colClass}>
                <label className={`detail-label ${labelClassName ? labelClassName : ""} ${fromInventory ? "d-flex justify-content-between" : ""}`}>
                    <div> {label} <span className="text-danger">{required && "*"}</span></div>
                    {(fromInventory?.is_edit && fromInventory?.fromProject) ?
                        <div className="c-pointer" onClick={() => setInventoryEdit(name)}><FontAwesomeIcon icon="fa-solid fa-edit" /></div>
                        : ""}
                </label>
                <div className="d-flex gap-2 align-items-center">
                    <Autocomplete
                        className="common-autocomplete"
                        key={formValues[name] ? formValues[name] : "empty"}
                        value={formValues[name] === undefined || formValues[name] === null ? null : formValues[name]}
                        options={option || []}
                        getOptionLabel={(opt) => (typeof opt === "string" ? opt : opt.label ?? "")}
                        onChange={(_event, newValue) => {
                            let val;
                            if (typeof newValue === "string") {
                                val = newValue;
                            } else if (newValue && newValue.inputValue) {
                                val = newValue.inputValue;
                            } else if (newValue && typeof newValue === "object") {
                                val = newValue.value ?? newValue.label ?? "";
                            } else {
                                val = "";
                            }
                            handleChange({
                                target: {
                                    name,
                                    value: val,
                                }
                            });
                        }}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            const { inputValue } = params;
                            if (
                                inputValue !== "" &&
                                !options.some((option) => inputValue === option.label)
                            ) {
                                filtered.push({
                                    inputValue,
                                    label: inputValue,
                                    value: inputValue
                                });
                            }
                            return filtered;
                        }}
                        renderOption={(props, option) => (
                            <li {...props} key={option.value}>
                                {option.label}
                            </li>
                        )}
                        sx={MuiCss}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                sx={MuiTextInputStyle}

                                onBlur={(e) => {
                                    const value = e.target.value;
                                    if (
                                        typeof value === "string"
                                    ) {
                                        handleChange({
                                            target: {
                                                name,
                                                value: value,
                                            }
                                        });
                                    }
                                }}
                            />
                        )}
                        fullWidth
                        freeSolo
                        disabled={disabled}
                    />
                    {/* {(fromInventory && option?.filter(item => item?.label === formValues?.[name]?.label)?.length > 0 && !fromInventory?.is_edit) ?
                        <div className="c-pointer" onClick={() => setInventoryEdit(name)}><FontAwesomeIcon icon="fa-solid fa-edit" /></div>
                        : ""} */}
                </div>
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        );
    }

    if (type === "timepicker") {
        return (
            <div key={index} className={`${colClass} w100`}>
                <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>
                    {label} <span className="text-danger">{required && "*"}</span>
                </label>
                <TimePicker value={formValues[name] || null} onChange={handleChange} disabled={disabled} sx={{ ...timePickerMuiCss, margin: "2px 2px" }}
                    slotProps={{
                        textField: {
                            label: undefined,
                            placeholder: "Select time"
                        }
                    }} />
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        )
    }
    if (type === "checkbox") {
        return (
            <div key={index} className={`${colClass} w100`}>
                <div className="d-flex align-items-center gap-1">
                    <input
                        name={name}
                        type={type}
                        className="input-dd w100"
                        onChange={(e) => handleChange(e, false)}
                        checked={formValues[name]}
                        disabled={disabled}
                        id={label}
                    />
                    <label className={`detail-label ${labelClassName ? labelClassName : ""}`} htmlFor={label}>
                        {label}
                    </label>
                </div>
                {error && (
                    <div className="text-danger" style={{ fontSize: "12px" }}>
                        {error}
                    </div>
                )}
            </div>
        )
    }


    return (
        <div key={index} className={`${colClass} w100`}>
            <label className={`detail-label ${labelClassName ? labelClassName : ""}`}>{label} {`${formValues[name] ? `: ${formValues[name]}` : ""}`}</label><br></br>
        </div>
    )

};
export const RenderSignatureField = ({ name, value, handleChange, lable }) => {
    return (
        <div className={``}>
            {value[name] && (
                <div className="d-flex gap-2 align-items-end">
                    {value[name] && (
                        <img
                            src={
                                typeof value[name] === 'string'
                                    ? value[name]
                                    : URL.createObjectURL(value[name])
                            }
                            alt=""
                            width={80}
                            height={80}
                        />
                    )}
                </div>
            )}
            <input
                id={`fileInput-${name}`}
                name={name}
                type="file"
                onChange={handleChange}
                style={{ display: value[name] ? 'none' : 'block' }}
            />
            {lable}
        </div>
    )
}
export const renderRows = (fields, values, section, idx) => {
    return fields.map((field, index) => {
        let value = values?.[field.key] || "";

        if (field.type === "date") {
            value = dateConvert(value, "day-mon-year");
        }

        return (
            <tr key={`${section}-${index}`}>
                <td>{idx + index}</td>
                <td>{field.label}</td>
                <td>{value}</td>
            </tr>
        );
    });
};

// Helper to convert image to base64 format
export const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => resolve(reader.result);

        reader.onerror = (error) => reject(error);
    });
};

export const timeOptions = [
    ...Array.from({ length: 8 }, (_, i) => ({
        value: i + 1,
        label: `${i + 1}h`,
    })),
    { value: 16, label: "16h" },
    { value: 24, label: "1d" },
    { value: 48, label: "2d" },
    { value: 72, label: "3d" },
];

export const getFullMonthSelected = (date) => {
    const today = date ? new Date(date) : new Date();
    const currYear = today?.getFullYear();
    const currMonth = String(today?.getMonth() + 1)?.padStart(2, '0');
    const endDay = new Date(today?.getFullYear(), (today?.getMonth() + 1), 0).getDate();
    const start = new Date(currMonth + "-01-" + currYear);
    const end = new Date(currMonth + "-" + endDay + "-" + currYear);
    return { from_date: start, to_date: end }
}

export const dateHoverRange = (hoveredRange) => {
    return hoveredRange?.toDate().toLocaleDateString("en-GB").split("/").reverse().join("-")
}

export const timeStringToDate = (timeStr, selectedDate) => {
    if (!timeStr) { return; }
    const [hours, minutes, seconds] = timeStr?.split(':')?.map(Number);
    const date = selectedDate ? new Date(selectedDate) : new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
}

export const getCustomPaginationValues = (currentPage, dataLength) => {
    const total = Math.ceil(dataLength / 10);
    const start = (currentPage - 1) * 10 + 1;
    const end = Math.min(currentPage * 10, dataLength);
    const displayPageOutOfTotal = `${start}-${end} of ${dataLength}`;
    return { total, displayPageOutOfTotal };
}

export const calculateWordsFromString = (val) => {
    let para = val?.trim()?.split(" ");
    para = para?.filter(item => item?.length > 0);
    return para?.length
}

export const expriryData = [
    { label: "1 Week", value: "1week" },
    { label: "15 Days", value: "15days" },
    { label: "1 Month", value: "1month" },
    { label: "3 Months", value: "3months" },
    // { label: "6 Months", value: "6months" }
]

export const handleDurationSelect = (value) => {
    const today = new Date();
    let futureDate = new Date(today);

    switch (value) {
        case "1week":
            futureDate.setDate(today.getDate() + 7);
            break;
        case "15days":
            futureDate.setDate(today.getDate() + 15);
            break;
        case "1month":
            futureDate.setMonth(today.getMonth() + 1);
            break;
        case "3months":
            futureDate.setMonth(today.getMonth() + 3);
            break;
        case "6months":
            futureDate.setMonth(today.getMonth() + 6);
            break;
        default:
            return;
    }

    return futureDate
};

export const generateTimeSlots = (slotDurationInMinutes, from, to, keepExactEndTime) => {
    const interval = parseInt(slotDurationInMinutes);
    const fromTime = timeStringToDate(from);
    const toTime = timeStringToDate(to);
    const formattedToTime = keepExactEndTime ? toTime : (toTime?.getMinutes() === 30 ? (new Date()).setHours(toTime?.getHours() + 1, 0, toTime?.getSeconds() || 0, 0) : toTime);

    const timeSlots = [];
    let current = new Date(fromTime);

    while (current < formattedToTime) {
        const next = new Date(current.getTime() + interval * 60000);

        if (next > formattedToTime) break;

        timeSlots.push({
            label: `${dateConvert(current, "time")} - ${dateConvert(next, "time")}`,
            value: {
                start: convertTo24HourFormat(dateConvert(current, "time"), true),
                end: convertTo24HourFormat(dateConvert(next, "time"), true)
            }
        });

        current = next;
    }

    return timeSlots
}


export function humanizeTimeDiff(diff_years, diff_months, diff_days, diff_hours, diff_seconds) {
    if (diff_years >= 1) return `${diff_years} ${diff_years === 1 ? 'year' : 'years'} ago`;
    if (diff_months >= 1) return `about ${diff_months} ${diff_months === 1 ? 'month' : 'months'} ago`;
    if (diff_days >= 1) return `${diff_days} ${diff_days === 1 ? 'day' : 'days'} ago`;
    if (diff_hours >= 1) return `${diff_hours} ${diff_hours === 1 ? 'hour' : 'hours'} ago`;
    if (diff_seconds >= 1) return `${diff_seconds} ${diff_seconds === 1 ? 'second' : 'seconds'} ago`;
    return null;
}


export const timePickerMuiCss = {
    "&.MuiFormControl-root.MuiPickersTextField-root": {
        width: "100%",
        backgroundColor: "var(--bg-color) !important",
        borderRadius: "4px",
    },
    "& .MuiPickersInputBase-root": {
        padding: "0 8px",
        display: "flex",
        alignItems: "center",
        backgroundColor: "var(--bg-color) !important",
        color: "var(--text-color) !important",
    },
    "& .MuiPickersInputBase-sectionsContainer": {
        padding: "5px 0px 5px 0px",
        fontSize: "0.80rem",
        display: "flex",
        alignItems: "center",
        height: "100%",
    },
    "& .MuiSvgIcon-root": {
        fontSize: "1.1rem",
        color: "var(--text-color) !important",
    },
    "& .MuiInputAdornment-root": {
        display: "flex",
        alignItems: "center",
        width: "35px"
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "var(--grid-border-color) !important",
    },
    "& .MuiInputBase-input": {
        color: "var(--text-color) !important",
    }
}

export const getPreviousMonths = (count) => {
    const months = [];
    const date = new Date();

    for (let i = 0; i < count; i++) {
        const d = new Date(date.getFullYear(), date.getMonth() - i, 1);
        const label = d.toLocaleString('en-US', {
            month: 'short',
            year: 'numeric'
        });

        months.push({
            label: label,
            month: d.getMonth() + 1,
            year: d.getFullYear()
        });
    }

    return months;
};



export const parseExcelFormula = (formula, rowData, allColKeys) => {
    if (!formula || !formula.startsWith('=')) return formula;

    try {
        let jsFormula = formula.slice(1).trim();
        const functionMap = {
            'MAX': 'Math.max',
            'MIN': 'Math.min',
            'ABS': 'Math.abs',
            'SQRT': 'Math.sqrt',
            'POW': 'Math.pow'
        };
        Object.keys(functionMap).forEach(key => {
            const regex = new RegExp(`${key}\\s*\\(`, 'gi');
            jsFormula = jsFormula.replace(regex, `${functionMap[key]}(`);
        });

        // 1. SUM(a, b, c) -> (a + b + c)
        jsFormula = jsFormula.replace(/SUM\s*\((.*?)\)/gi, (match, args) => {
            return `(${args.split(',').join('+')})`;
        });

        // 2. AVERAGE(a, b, c) -> ((a + b + c) / count)
        jsFormula = jsFormula.replace(/AVERAGE\s*\((.*?)\)/gi, (match, args) => {
            const parts = args.split(',');
            return `((${parts.join('+')}) / ${parts.length})`;
        });

        // 3. ROUND(val, digits) -> Number(val).toFixed(digits)
        jsFormula = jsFormula.replace(/ROUND\s*\((.*),\s*(.*)\)/gi, (match, val, pts) => {
            return `(Number(${val}).toFixed(${pts}))`;
        });

        // 4. IF(cond, true, false)
        if (jsFormula.toUpperCase().includes('IF(')) {
            jsFormula = jsFormula.replace(/IF\s*\((.*),\s*(.*),\s*(.*)\)/gi, '($1 ? $2 : $3)');
        }

        // 5. CONCAT(a, b) -> (a + b)
        jsFormula = jsFormula.replace(/CONCAT\s*\((.*?)\)/gi, (match, args) => {
            return `(${args.split(',').join('+')})`;
        });

        const sortedKeys = [...allColKeys].sort((a, b) => b.length - a.length);
        const colPattern = new RegExp(`\\b(${sortedKeys.join('|')})\\b`, 'g');

        const finalEval = jsFormula.replace(colPattern, (match) => {
            const val = rowData[match];
            if (val === null || val === undefined) return 0;
            return isNaN(val) ? `"${val}"` : val;
        });

        return new Function(`return ${finalEval}`)();
    } catch (e) {
        console.error("Formula Error:", e);
        return "#VALUE!";
    }
};


export const getStatusStyle = (status) => {
    if (status?.toLowerCase() === 'done' || status?.toLowerCase() === 'RESOLVED') return { backgroundColor: '#b3df72' };
    if (status?.toLowerCase() === 'in progress') return { backgroundColor: '#579dff', };
    if (status?.toLowerCase() === 'dev done') return { backgroundColor: '#8fb8f6' };
    if (status?.toLowerCase() === 'backlog' || status?.toLowerCase() === 'sprint backlog') return { backgroundColor: '#dddee1' };
    return { backgroundColor: '#dddee1' };
};

export const getFileIcon = (fileType) => {
    const type = fileType?.toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(type)) {
        return 'fa-solid fa-file-image';
    }
    if (type === 'pdf') {
        return 'fa-solid fa-file-pdf';
    }
    if (['doc', 'docx'].includes(type)) {
        return 'fa-solid fa-file-word';
    }
    if (['xlsx', 'xls'].includes(type)) {
        return 'fa-solid fa-file-excel';
    }
    if (['pptx', 'ppt'].includes(type)) {
        return 'fa-solid fa-file-powerpoint';
    }
    if (['html', 'htm'].includes(type)) {
        return 'fa-solid fa-file-code';
    }
    return 'fa-solid fa-file';
};

export const groupByTwoKeys = (arr, key1, key2) => {
    return arr?.reduce((acc, item) => {
        const compositeKey = `${item[key1]}|${item[key2]}`;
        if (!acc[compositeKey]) acc[compositeKey] = [];
        acc[compositeKey].push(item);
        return acc;
    }, {});
};